import { useState, type ReactNode } from 'react'
import { faviconUrl, isNotDefined } from '@terros/common'
import { Center, Group, Image } from '@mantine/core'
import { SizePrimitives } from '@front/model'
import { MaterialSymbolIcon } from '@components'
import { type PreviewSocialLink } from './previewContent'

type Props = {
  links: PreviewSocialLink[]
  background: string
  color: string
}

export const PreviewSocialLinks = ({ links, background, color }: Props): ReactNode => (
  <Group gap='md' justify='center'>
    {links.map((link) => (
      <PreviewSocialIcon key={link.key} url={link.url} background={background} color={color} />
    ))}
  </Group>
)

type PreviewSocialIconProps = {
  url: string
  background: string
  color: string
}

function toFaviconSrc(url: string): string | undefined {
  try {
    return faviconUrl(url)
  } catch {
    return undefined
  }
}

const PreviewSocialIcon = ({ url, background, color }: PreviewSocialIconProps): ReactNode => {
  const [faviconFailed, setFaviconFailed] = useState(false)
  const src = toFaviconSrc(url)

  if (isNotDefined(src) || faviconFailed) {
    return (
      <Center bg={background} bdrs='full' c={color} h={SizePrimitives['11']} w={SizePrimitives['11']}>
        <MaterialSymbolIcon icon='public' size='lg' />
      </Center>
    )
  }

  return (
    <Image
      src={src}
      alt=''
      onError={() => setFaviconFailed(true)}
      bdrs='md'
      fit='contain'
      h={SizePrimitives['11']}
      w={SizePrimitives['11']}
    />
  )
}
